import React, { useState, useCallback, useEffect } from "react";
import Heading from "../ui/Heading";
import { Col, Container, Image, Row } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom/cjs/react-router-dom";
import { isMobile, isTablet } from "react-device-detect";
import Slider from "react-slick";
import { ImageUrl, Je_welryspelling } from "../../../../../Helpers/request";
import  arrowleft from '../assets/images/arrow-left-green.png'
import  arrowright from '../assets/images/arrow-right-green.png'

const data = [
  { name: "Round", para: "Cut with the optimum light refraction and sparkle.", image: `${ImageUrl}diamond-shape/round-diamond.webp`, url: "/diamonds/shape=Round" },
  { name: "Princess", para: "A contemporary cut, with optimal fire and brilliance.", image: `${ImageUrl}diamond-shape/princess-diamond.webp`, url: "/diamonds/shape=Princess" },
  { name: "Cushion", para: "With soft corners, a beautiful alternative to a round or princess cut.", image: `${ImageUrl}diamond-shape/cushion-diamond.webp`, url: "/diamonds/shape=Cushion" },
  { name: "Emerald", para: "This stylish cut creates rectangular facets with great stone clarity.", image: `${ImageUrl}diamond-shape/emerald-diamond.webp`, url: "/diamonds/shape=Emerald" },
  { name: "Oval", para: "Optimizes carat, giving the illusion of a larger stone.", image: `${ImageUrl}diamond-shape/oval-diamond.webp`, url: "/diamonds/shape=Oval" },
  { name: "Radiant", para: "The most brilliant of the rectangular cut diamonds.", image: `${ImageUrl}diamond-shape/radiant-diamond.webp`, url: "/diamonds/shape=Radiant" },
  { name: "Asscher", para: "This unique shape is a square emerald, with linear facets.", image: `${ImageUrl}diamond-shape/asscher-diamond.webp`, url: "/diamonds/shape=Asscher" },
  { name: "Marquise", para: "Elongates the finger of the wearer with a look of great grandeur.", image: `${ImageUrl}diamond-shape/marquise-diamond.webp`, url: "/diamonds/shape=Marquise" },
  { name: "Heart", para: "A rare cut that is a true testament of your relationship.", image: `${ImageUrl}diamond-shape/heart-diamond.webp`, url: "/diamonds/shape=Heart" },
  { name: "Pear", para: "Combining the brilliance and design of the Round and Marquise cuts.", image: `${ImageUrl}diamond-shape/pear-diamond.webp`, url: "/diamonds/shape=Pear" },
];



const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
  arrows: false,
  slidesToShow: 10,
  slidesToScroll: 1,
  prevArrow: <Image src={arrowleft} alt="left arrow" />,
  nextArrow: <Image src={arrowright} alt=" Rigth arrow" />,
  responsive: [
    { breakpoint: 1024, settings: { slidesToShow: 5, slidesToScroll: 1,  arrows: true, } },
    { breakpoint: 600, settings: { slidesToShow: 4, slidesToScroll: 2,  arrows: true, } },
    { breakpoint: 480, settings: { slidesToShow: 3, slidesToScroll: 1 ,  arrows: true,} },
  ],
  beforeChange: () => {
    setTimeout(() => {
      const slides = document.querySelectorAll(".slick-slide");
      slides.forEach((slide) => {
        const isHidden = slide.getAttribute("aria-hidden") === "true";
        slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
          el.setAttribute("tabindex", isHidden ? "-1" : "0");
        });
      });
    }, 100); // You can increase this to 300–500ms if needed
  }
};

const ShopByDiamondShape = () => {

  useEffect(() => {
      const updateTabIndex = () => {
        document.querySelectorAll(".slick-slide[aria-hidden='true']").forEach((slide) => {
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", "-1");
          });
        });
    
        document.querySelectorAll(".slick-slide[aria-hidden='false']").forEach((slide) => {
          slide.querySelectorAll("a, button, input, textarea, select").forEach((el) => {
            el.setAttribute("tabindex", "0");
          });
        });
      };
    
      // Run on mount
      updateTabIndex();
    
      // Re-run after a short delay in case of dynamic content
      setTimeout(updateTabIndex, 500);
    }, []);

  const history = useHistory();
  const [diamondItem, setDiamondItem] = useState(data[0]);

  // Optimize re-renders using useCallback
  const handleClick = useCallback((item) => {
    setDiamondItem(item);
  }, []);

  return (
    <section className="shop-diamond-by-shape">
      <Container fluid className="showcase-container">
        <Heading>
          <h2>Shop Diamonds By Shape</h2>
          <p>To discover the perfect cut that complements your unique style.</p>
          
        </Heading>
        <Row>
          <Col sm={12} md={12} lg={12}>
          <div className="inner-shop-diamond-shape">
        
        <div className="diamonds-collection">
          <Slider {...sliderSettings}>
            {data.map((item) => (
              <div
                className="diamond-item cursor-pointer"
                key={item.name}
                onClick={() => history.push(item.url)}
              >
                <Image src={item.image} alt={item.name} loading="lazy" />
                {/* <p className={diamondItem.name === item.name ? "name" : ""}>{item.name}</p> */}
                <p className="shapeName">{item.name}</p>
           
              </div>
            ))}
          </Slider>
        </div>
     
    </div>
          </Col>
        </Row>

    
      </Container>
    </section>
  );
};

export default ShopByDiamondShape;
